import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=ae8c6210&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8c6210",
  null
  
)

export default component.exports